import Vue from 'vue'
import store from '@/store'
import router from '@/router'

import axios from 'axios'
import Notifications from 'vue-notification'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import App from '@/App.vue'
import VueMask from 'v-mask'

import './registerServiceWorker'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './../public/fonts/style.css'
import './main.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Notifications)
Vue.use(VueMask);
new Vue({
  router,
  store,

  render: h => h(App)
}).$mount('#app')
